export default "/images/841f7a394069255228181b94932b5997.png";